import { ConditionalWrapperProps } from "./ConditionalWrapper.types";

const ConditionalWrapper: React.FC<ConditionalWrapperProps> = ({
  condition,
  wrapper,
  children,
}): any => (condition ? wrapper(children as any) : children);

export default ConditionalWrapper;
